import React from 'react';
import * as R from 'ramda';
import axios from 'axios';

export default class DeleteWarning extends React.Component {
    static DISPLAY_STATES = {
        WARNING: 'warning',
        DELETE: 'delete',
        LOADING: 'loading',
        SUCCESS: 'success',
        FAILED: 'failed'
    };

    static defaultProps = {
        refreshCallback: R.always(null)
    };

    constructor(props) {
        super(props);
        this.state = {
            display: DeleteWarning.DISPLAY_STATES.WARNING
        };
    }

    displayWarning = () => {
        this.setState({
            display: DeleteWarning.DISPLAY_STATES.WARNING
        });
    };

    displayDelete = () => {
        this.setState({
            display: DeleteWarning.DISPLAY_STATES.DELETE
        });
    };

    displayLoading = () => {
        this.setState({
            display: DeleteWarning.DISPLAY_STATES.LOADING
        });
    };

    displaySuccess = () => {
        this.setState({
            display: DeleteWarning.DISPLAY_STATES.SUCCESS
        });
    };

    displayFailed = () => {
        this.setState({
            display: DeleteWarning.DISPLAY_STATES.FAILED
        });
    };

    sendDeleteRequest = () => {
        const {deleteUrl, refreshCallback} = this.props;

        this.displayLoading();

        axios
            .delete(deleteUrl)
            .then(response => {
                this.displaySuccess();
                refreshCallback();
            })
            .catch(response => {
                this.displayFailed();
            });
    };

    render() {
        const {deleteType, deleteId, deleteName} = this.props;
        const {display} = this.state;
        const displayStates = DeleteWarning.DISPLAY_STATES;
        const functions = {
            displayWarning: this.displayWarning,
            displayDelete: this.displayDelete,
            displayLoading: this.displayLoading,
            displaySuccess: this.displaySuccess,
            displayFailed: this.displayFailed,
            sendDeleteRequest: this.sendDeleteRequest
        };

        return (
            <DeleteButton
                deleteType={deleteType}
                deleteId={deleteId}
                deleteName={deleteName}
                display={display}
                displayStates={displayStates}
                functions={functions}
            />
        );
    }
}

class DeleteButton extends React.Component {
    getButtonProps = () => {
        const {deleteType, deleteId, deleteName, display, displayStates, functions} = this.props;

        const commonClasses = 'modal-body delete-modal-body btn';

        if (display === displayStates.WARNING) {
            return {
                message: `Delete ${deleteType} #${deleteId}: ${deleteName}?`,
                classes: `${commonClasses} btn-warning`,
                onclick: functions.displayDelete
            };
        }

        if (display === displayStates.DELETE) {
            return {
                message: `Delete ${deleteType} #${deleteId}: ${deleteName}`,
                classes: `${commonClasses} btn-danger`,
                onclick: functions.sendDeleteRequest
            };
        }

        if (display === displayStates.LOADING) {
            return {
                message: 'Loading...',
                classes: `${commonClasses} btn-info`,
                onclick: null
            };
        }

        if (display === displayStates.SUCCESS) {
            return {
                message: `${deleteType} #${deleteId}: ${deleteName} deleted.`,
                classes: `${commonClasses} btn-success`,
                onclick: null
            };
        }

        if (display === displayStates.FAILED) {
            return {
                message: 'Delete failed. Try again?',
                classes: `${commonClasses} btn-danger`,
                onclick: functions.displayWarning
            };
        }

        return {
            message: null,
            classes: null,
            onclick: null
        };
    };

    render() {
        const {message, classes, onclick} = this.getButtonProps();

        return (
            <button onClick={onclick} className={classes}>
                {message}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./components/delete_warning.js